jQuery(document).ready(function($) {
    $('.custom-accordion .accordion-header').on('click', function () {
        const item = $(this).closest('.accordion-item');
        const content = item.find('.accordion-content');

        if (item.hasClass('open')) {
            item.removeClass('open');
            content.slideUp(200);
        } else {
            // Close all
            $('.custom-accordion .accordion-item').removeClass('open');
            $('.custom-accordion .accordion-content').slideUp(200);

            // Open clicked
            item.addClass('open');
            content.slideDown(200);
        }
    });
    // Swap clicked gallery image with the main .accordion-img image
    $(document).on(
        "click",
        ".product-usage-accordion .accordion-gallery img",
        function (e) {
            e.preventDefault();

            const $thumb = $(this);                                // clicked gallery image
            const $item  = $thumb.closest(".accordion-item");      // the current accordion item

            // Find or create the main image wrapper and <img>
            let $mainWrap = $item.find(".accordion-img").first();
            if (!$mainWrap.length) {
                // If the item had no main image, create the wrapper in the left column
                const $leftCol =
                    $item.find(".col-lg-6.col-12").first(); // matches your markup
                $mainWrap = $('<div class="accordion-img">').prependTo($leftCol);
            }
            let $mainImg = $mainWrap.find("img").first();
            if (!$mainImg.length) {
                $mainImg = $('<img class="img-fluid" alt="">').appendTo($mainWrap);
            }

            // Read attributes to swap (handle src, alt, srcset, sizes if present)
            const mainAttrs = {
                src:    $mainImg.attr("src") || "",
                alt:    $mainImg.attr("alt") || "",
                srcset: $mainImg.attr("srcset") || "",
                sizes:  $mainImg.attr("sizes") || "",
            };
            const thumbAttrs = {
                src:    $thumb.attr("src") || "",
                alt:    $thumb.attr("alt") || "",
                srcset: $thumb.attr("srcset") || "",
                sizes:  $thumb.attr("sizes") || "",
            };

            if (!thumbAttrs.src) return; // nothing to swap

            // Fade the main image for a smoother swap
            $mainImg.stop(true, true).fadeOut(150, function () {
                // Put clicked thumb into main image
                $mainImg
                    .attr({
                        src: thumbAttrs.src,
                        alt: thumbAttrs.alt,
                    })
                    .toggleAttr("srcset", thumbAttrs.srcset)
                    .toggleAttr("sizes", thumbAttrs.sizes)
                    .fadeIn(150);
            });

            // Put previous main image back into the clicked gallery slot (thumbnail style)
            if (mainAttrs.src) {
                $thumb
                    .attr({
                        src: mainAttrs.src,
                        alt: mainAttrs.alt,
                    })
                    .toggleAttr("srcset", mainAttrs.srcset)
                    .toggleAttr("sizes", mainAttrs.sizes);
            }

            // Optional: mark the active thumbnail
            $thumb
                .closest(".accordion-gallery")
                .find("img")
                .removeClass("is-active");
            $thumb.addClass("is-active");
        }
    );

    // Small helper to add/remove attributes if empty — keeps markup tidy
    $.fn.toggleAttr = function (name, val) {
        return this.each(function () {
            if (val) $(this).attr(name, val);
            else $(this).removeAttr(name);
        });
    };
});
